import { render, staticRenderFns } from "./EmergencyMessage.vue?vue&type=template&id=82cbcbb0&scoped=true"
import script from "./EmergencyMessage.vue?vue&type=script&lang=js"
export * from "./EmergencyMessage.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMessage.vue?vue&type=style&index=0&id=82cbcbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cbcbb0",
  null
  
)

export default component.exports